import React, { useState, useEffect } from 'react';
import "./hotels.css";
import Sidebar from '../../../Components/Sidebar/Sidebar';
import hotels1 from "../../../Assets/hotels.jpg";
import { Link } from 'react-router';
import hotels2 from "../../../Assets/sound-barrier-india.webp";
import hotels3 from "../../../Assets/hotels/Hotel-Sb.png";
import hotels4 from "../../../Assets/sound-barrier-manufacturer.webp";
import hotels5 from "../../../Assets/hotels/hotel-1.png";
import hotels6 from "../../../Assets/hotels/hotel-2.png";
import hotels7 from "../../../Assets/hotels/hotel-3.png";
import hotels8 from "../../../Assets/hotels/hotel-4.png";
import hotels9 from "../../../Assets/hotels/hotel-5.png";
import hotels10 from "../../../Assets/hotels/hotel-6.png";
import HNavbar from '../../../Components/Navbar/HNavbar';
import MFooter from '../../../Components/Main-Footer/MFooter';

function Hotels() {
    const [showTopBtn, setShowTopBtn] = useState(false);

    const handleClick = () => {
        const name = document.getElementById('name').value.trim();
        const mail = document.getElementById('mail').value.trim();
        const phone = document.getElementById('phone').value.trim();
        const message = document.getElementById('message').value.trim();

        const subject = `New message from ${name}`
        const body = `Name: ${name}%0AEmail: ${mail}%0APhone: ${phone}%0A%0AMessage:%0A${message}`;
        const mailtoLink = `mailto:mail@acousticalsurfaces.in?subject=${encodeURIComponent(subject)}&body=${body}`;

        window.open(mailtoLink, '_blank');

        document.getElementById('name').value = '';
        document.getElementById('mail').value = '';
        document.getElementById('phone').value = '';
        document.getElementById('message').value = '';
    }
    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 400) {
                setShowTopBtn(true);
            } else {
                setShowTopBtn(false);
            }
        };
        window.addEventListener('scroll', handleScroll);

        return () => window.removeEventListener('scroll', handleScroll);
    }, []);
    useEffect(() => {
        const animatedElements = document.querySelectorAll('.hotel-header,.hotel-header1,.hotel-header2,.hotel-header3,.hotel-header4,.hotel-header5,.hotel-header6');

        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('animate');
                } else {
                    entry.target.classList.remove('animate');
                }
            });
        }, { threshold: 0.3 });

        animatedElements.forEach(el => observer.observe(el));

        return () => {
            animatedElements.forEach(el => observer.unobserve(el));
        };
    }, []);
    return (
        <>
        <HNavbar />
            <section id='hotels' className='home-hotels'>
                <div className='container p-0'>
                    <Sidebar />
                    <div className='row main-hotels'>
                        <div className='col-12 col-md-6 d-flex justify-content-center align-items-center p-3'>
                            <div className='image-wrapper'>
                                <img className='img-fluid hotels-home-img' src={hotels1} alt="hotels" />
                            </div>
                        </div>
                        <div className='col-12 col-md-6 d-flex flex-column justify-content-center align-items-start text-white'>
                            <h1 className='hotel-header'>Hotel Noise Control Solutions | Sound Barrier</h1>
                            <p className='white-para'>Hotels require a peaceful and comfortable environment for guests. Noise from generators, HVAC systems, nearby traffic, construction activities, and events can disturb hotel customers. Sound Barrier Manufacture provides professional hotel noise control solutions using high-performance sound barrier blankets and acoustic systems.</p>
                            <p className='white-para'>Our hotel sound barrier solutions are designed to reduce noise disturbance and improve guest comfort.</p>
                            <Link to="/contact"><button className='btn' type="button">Contact us</button></Link>
                        </div>
                    </div>
                </div>
            </section >
            <section id='hotels'>
                <div className='container noice-control mt-4'>
                    <h1 className='hotel-header1'>Why Noise Control is Important in Hotels</h1>
                    <p>Guest satisfaction depends on a quiet and relaxing atmosphere. Excessive noise can cause:</p>
                    <div className='row'>
                        <div className='col-sm-12 col-md-6 d-flex justify-content-center'>
                            <img className='img-fluid' src={hotels2} alt="hotels" style={{ height: "500px" }} />
                        </div>
                        <div className='col-sm-12 col-md-6 d-flex flex-column align-items-center justify-content-center'>
                            <ul className='list'>
                                <li>Customer complaints</li>
                                <li>Poor online reviews</li>
                                <li>Sleep disturbance for guests</li>
                                <li>Event and conference interruptions</li>
                                <li>Reduced brand reputation</li>
                            </ul>
                        </div>
                    </div>
                    <p>Installing proper hotel noise control systems ensures better guest experience and comfort.</p>

                    <h1 className='hotel-header2' style={{ marginTop: "10px" }}>Our Hotel Sound Barrier Solutions</h1>
                    <p>Sound Barrier Manufacture supplies durable and high-performance sound barrier blankets suitable for hotel environments.</p>
                    <div className='row mt-5'>
                        <div className='col-sm-12 col-md-6'>
                            <h5>Key Features:</h5>
                            <ul className='list'>
                                <li>High STC-rated sound barrier material</li>
                                <li>Fire-retardant and safe materials</li>
                                <li>Suitable for indoor and outdoor use</li>
                                <li>Easy installation and removal</li>
                                <li>Custom sizes available</li>
                                <li>Reusable and long-lasting performance</li>
                            </ul>
                            <p>Our acoustic barriers can be used for temporary or permanent noise control applications in hotels.</p>
                        </div>
                        <div className='col-sm-12 col-md-6'>
                            <img className='img-fluid' src={hotels3} alt="hotels" style={{ height: "400px" }} />
                        </div>
                    </div>

                    <h1 className='hotel-header3' style={{ marginTop: "30px" }}>Benefits of Hotel Noise Control Systems</h1>
                    <p>Using hotel sound barriers helps:</p>
                    <div className='row'>
                        <div className='col-sm-12 col-md-6'>
                            <img className='img-fluid' src={hotels4} alt="hotels" />
                        </div>
                        <div className='col-sm-12 col-md-6 d-flex flex-column align-items-center justify-content-center'>
                            <ul className='list'>
                                <li>Reduce guest disturbance</li>
                                <li>Improve customer satisfaction</li>
                                <li>Protect hotel reputation</li>
                                <li>Maintain a peaceful environment</li>
                                <li>Meet environmental noise standards</li>
                            </ul>
                        </div>
                    </div>
                    <h1 className='hotel-header4' style={{ marginTop: "20px" }}>Applications in Hotels</h1>
                    <h4 className='sub-title mt-3'>Our noise control solutions are ideal for:</h4>
                    <div className='row'>
                        <div className='col-sm-3 d-flex flex-column justify-content-center align-items-center'>
                            <img className='img-fluid app-circle-img' src={hotels5} alt="Generator room noise control" />
                            <p>Generator room noise control</p>
                        </div>
                        <div className='col-sm-3 d-flex flex-column justify-content-center align-items-center'>
                            <img className='img-fluid app-circle-img' src={hotels6} alt="HVAC and plant room enclosures" />
                            <p>HVAC and plant room enclosures</p>
                        </div>
                        <div className='col-sm-3 d-flex flex-column justify-content-center align-items-center'>
                            <img className='img-fluid app-circle-img' src={hotels7} alt="Banquet hall sound control" />
                            <p>Banquet hall sound control</p>
                        </div>
                        <div className='col-sm-3 d-flex flex-column justify-content-center align-items-center'>
                            <img className='img-fluid app-circle-img' src={hotels8} alt="Rooftop equipment" />
                            <p>Rooftop equipment noise reduction</p>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-sm-4 d-flex flex-column justify-content-center align-items-center'>
                            <img className='img-fluid app-circle-img' src={hotels9} alt="renovation inside hotels" />
                            <p>Construction or renovation inside hotels</p>
                        </div>
                        <div className='col-sm-4 d-flex flex-column justify-content-center align-items-center'>
                            <img className='img-fluid app-circle-img' src={hotels10} alt="Outdoor event noise management" />
                            <p>Outdoor event noise management</p>
                        </div>
                    </div>
                </div>
            </section>
            <section id='hotels' className='call'>
                <div className='container'>
                    <h1 className='hotel-header5'>Why Choose Us?</h1>

                    <ul className='hotel-list white-para'>
                        <li>Experienced acoustic solution provider</li>
                        <li>High-quality hotel sound barrier systems</li>
                        <li>Custom design and size options</li>
                        <li>Quick supply and installation support</li>
                        <li>Cost-effective noise control solutions</li>
                    </ul>
                    <p className='white-para'>We understand the importance of providing a calm and comfortable experience for hotel guests.</p>

                    <h1 className='hotel-header6'>Contact Us for Hotel Noise Control Solutions</h1>
                    <div className='row'>
                        <div className='col-sm-12 col-md-6 mt-2'>
                            <p className='white-para'>Looking for reliable noise control solutions for your hotel?</p>
                            <p className='white-para'>Sound Barrier Manufacture provides customized sound barrier systems designed to reduce hotel customer disturbance and improve overall comfort.</p>
                            <p className='white-para'>Contact us today for expert consultation and hotel noise control support.</p>
                        </div>
                        <div className='col-sm-12 col-md-6'>
                            <div className="row">
                                <div className="col-sm-12 col-md-4 mb-3">
                                    <input
                                        type="text"
                                        name="name"
                                        id="name"
                                        className="form-control"
                                        placeholder="Name *"
                                    />
                                </div>
                                <div className="col-sm-12 col-md-4 mb-3">
                                    <input
                                        type="email"
                                        name="mail"
                                        id="mail"
                                        className="form-control"
                                        placeholder="Email *"
                                    />
                                </div>
                                <div className="col-sm-12 col-md-4 mb-3">
                                    <input
                                        type="text"
                                        name="phone"
                                        id="phone"
                                        className="form-control"
                                        placeholder="Phone *"
                                    />
                                </div>
                                <div className="col-12 mb-3">
                                    <textarea
                                        rows={4}
                                        id="message"
                                        className="form-control"
                                        placeholder="Message *"
                                    ></textarea>
                                </div>
                                <div className="col-12">
                                    <button
                                        className="btn"
                                        type="button"
                                        onClick={handleClick}
                                    >
                                        SEND
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {showTopBtn && (
                <button className='scroll-to-top'
                    onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                > ↑ </button>
            )
            }
            <MFooter />
        </>
    )
}

export default Hotels